"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
var Units;
(function (Units) {
    Units["Wei"] = "Wei";
    Units["Kwei"] = "Kwei";
    Units["Mwei"] = "Mwei";
    Units["Gwei"] = "Gwei";
    Units["Szabo"] = "Szabo";
    Units["Finney"] = "Finney";
    Units["Ether"] = "Ether";
})(Units = exports.Units || (exports.Units = {}));
const base = new bn_js_1.default(10);
exports.unitsPow = {
    [Units.Wei]: new bn_js_1.default(1),
    [Units.Kwei]: base.pow(new bn_js_1.default(3)),
    [Units.Mwei]: base.pow(new bn_js_1.default(6)),
    [Units.Gwei]: base.pow(new bn_js_1.default(9)),
    [Units.Szabo]: base.pow(new bn_js_1.default(12)),
    [Units.Finney]: base.pow(new bn_js_1.default(15)),
    [Units.Ether]: base.pow(new bn_js_1.default(18)),
};
//# sourceMappingURL=constants.js.map